import ArticleIndex from 'components/pages/Article/Index'
import MetaTags from 'components/pages/Article/Index/MetaTags'
import withLivingSinyi from 'utils/withLivingSinyi'
import withSafeServerSideProps from 'utils/server-utils/with-safe-server-side-props'
import NoindexRemoval from 'components/common/NoindexRemoval'
import {
  getArticleLayout,
  getArticleClassifications,
  getArticles,
} from 'utils/api'

const ArticlesPage = (props) => {
  return (
    <>
      <NoindexRemoval />
      <MetaTags
        resolvedUrl={props.resolvedUrl}
        article={props.fallbackData?.layout?.mainArticles?.[0]}
      />
      <ArticleIndex {...props} />
    </>
  )
}

export const getServerSideProps = withSafeServerSideProps(async (context) => {
  const [layout, layoutError] = await getArticleLayout('mainArticles')
  const [alternateArticles, alternateArticleError] =
    layout?.mainArticles?.length < 6
      ? await getArticles({ limit: 6 - layout?.mainArticles?.length })
      : [[]]

  const [articleClassifications, error] = await getArticleClassifications()

  // 列表頁維持 200 降級（空狀態 UI），但 API 失敗要留下紀錄
  // 且 props 需 null 合併，避免 undefined 造成 Next 序列化錯誤
  if (layoutError || alternateArticleError || error) {
    const logger = require('utils/server-utils/logger')
    logger.warn({
      event: 'gssp_fetch_error_degraded',
      page: context.resolvedUrl,
      reason: (layoutError || alternateArticleError || error)?.message,
    })
  }

  return {
    props: {
      fallbackData: {
        layout: layout ?? null,
        alternateArticles: alternateArticles ?? [],
        articleClassifications: articleClassifications ?? [],
      },
      resolvedUrl: context.resolvedUrl,
    },
  }
})

export default withLivingSinyi(ArticlesPage)
